<template>
  <div>
    <a-card class="filter-data">
      <span slot="title">未开始的任务 ({{ not_begin_list.length }})</span>
      <a-table
        :pagination="pagination"
        :columns="columns"
        size="middle"
        :data-source="not_begin_list"
        :loading="loading"
        row-key="id"
      >
        <span slot="taskId" slot-scope="text, record" style="cursor: pointer" @click="onCopy(`TS-${record.id}`)">
          <div v-if="record.reason == 1" class="corner_reason1" />
          <div v-if="record.reason == 2" class="corner_reason2" />
          <div v-if="record.reason == 3" class="corner_reason3" />
          <span>{{ `TS-${record.id}` }}</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{
            taskStatus[record.status].label }}</a-tag>
        </span>
        <span slot="point" slot-scope="text, record">
          <span class="edit-point">
            {{ record.point }}<span class="task-points">({{ record.point * 2 }}人时)</span>
          </span>
        </span>
        <span slot="story" slot-scope="text, record">
          <a-tooltip v-if="record.req_title" placement="top" :title="record.req_title">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.req_title }}</a>
          </a-tooltip>
          <span v-else>--</span>
        </span>
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a class="custom-link" :href="taskLink(record)" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
      </a-table>
    </a-card>

    <a-card class="filter-data" style="margin-top: 10px;">
      <span slot="title">进行中任务 ({{ doing.length }})</span>
      <a-table
        :pagination="pagination"
        :columns="columns"
        size="middle"
        :data-source="doing"
        :loading="loading"
        row-key="id"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{
            taskStatus[record.status].label }}</a-tag>
        </span>
        <span slot="point" slot-scope="text, record">
          <span class="edit-point">
            {{ record.point }}<span class="task-points">({{ record.point * 2 }}人时)</span>
          </span>
        </span>
        <span slot="story" slot-scope="text, record">
          <a-tooltip v-if="record.req_title" placement="top" :title="record.req_title">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.req_title }}</a>
          </a-tooltip>
          <span v-else>--</span>
        </span>
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a class="custom-link" :href="taskLink(record)" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
      </a-table>
    </a-card>

    <a-card class="filter-data" style="margin-top: 10px;">
      <span slot="title">已完成任务 ({{ done.length }})</span>
      <a-table
        :pagination="pagination"
        :columns="columns"
        size="middle"
        :data-source="done"
        :loading="loading"
        row-key="id"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{
            taskStatus[record.status].label }}</a-tag>
        </span>
        <span slot="point" slot-scope="text, record">
          <span class="edit-point">
            {{ record.point }}<span class="task-points">({{ record.point * 2 }}人时)</span>
          </span>
        </span>
        <span slot="story" slot-scope="text, record">
          <a-tooltip v-if="record.req_title" placement="top" :title="record.req_title">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.req_title }}</a>
          </a-tooltip>
          <span v-else>--</span>
        </span>
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a class="custom-link" :href="taskLink(record)" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
      </a-table>
    </a-card>

    <a-card class="filter-data" style="margin-top: 10px;">
      <span slot="title">未解决Bug ({{ issues.length }})</span>
      <a-row>
        <a-col :span="12">
          <a-table
            :pagination="pagination"
            :columns="issueColumns"
            size="middle"
            :data-source="issues"
            :loading="loading"
            row-key="id"
          >
            <span slot="issueTitle" slot-scope="text, record">
              <a-tooltip placement="top" :title="record.title">
                <a class="custom-link" :href="issueLink(record)" target="_blank">{{ record.title }}</a>
              </a-tooltip>
            </span>
            <span slot="serious" slot-scope="text, record">
              <issue-serious-edit :source-id="record.id" :source-value="record.serious" />
            </span>
          </a-table>
        </a-col>
        <a-col :span="12">
          <issue-summary chart-id="issue-chart-1" :series-data="seriesData" />
        </a-col>
      </a-row>
    </a-card>
    <!-- <a-card style="margin-top: 10px;" class="issues-today">
        <span slot="title">今日新增Bug ({{ issuesToday.length }})</span>
        <a-row>
          <a-col :span="12">
            <a-table
              :pagination="pagination"
              :columns="issueColumns"
              size="middle"
              :data-source="issuesToday"
              :loading="loading"
              row-key="id"
            >
              <span slot="issueId" slot-scope="text, record" style="cursor: pointer" @click="onCopy(`BG-${record.id}`)">
                <div v-if="[1, 2, 7].includes(record.status)" class="corner_issue_unfinished" />
                <span>{{ `BG-${record.id}` }}</span>
              </span>
              <span slot="issueTitle" slot-scope="text, record">
                <a-tooltip placement="top" :title="record.title">
                  <a class="custom-link" :href="issueLink(record)" target="_blank">{{ record.title }}</a>
                </a-tooltip>
              </span>
              <span slot="serious" slot-scope="text, record">
                <issue-serious-edit :source-id="record.id" :source-value="record.serious" />
              </span>
            </a-table>
          </a-col>
          <a-col :span="12">
            <issue-summary chart-id="issue-chart-2" :series-data="seriesDataToday" />
          </a-col>
        </a-row>
      </a-card> -->
  </div>
</template>
<script>
import { faultLevels, taskStatus } from '@/utils/dictionary';
import { getDiagramInfo } from '@/api/data/quality';
import { onCopy } from '@/utils/utils';
import IssueSeriousEdit from '@/pages/project/issue/components/IssueSeriousEdit';
import IssueSummary from '@/pages/data/diagram/components/IssueSummary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'id',
    width: '7%',
    ellipsis: true,
    scopedSlots: { customRender: 'taskId' }
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    width: '25%',
    ellipsis: true,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '状态',
    width: '9%',
    dataIndex: 'status',
    ellipsis: true,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '负责人',
    dataIndex: 'user_name',
    width: '7%'
  },
  {
    title: '关联需求',
    dataIndex: 'req_title',
    width: '15%',
    ellipsis: true,
    scopedSlots: { customRender: 'story' }
  },
  {
    title: '预估工时',
    width: '7%',
    ellipsis: true,
    dataIndex: 'point',
    scopedSlots: { customRender: 'point' }
  },
  {
    title: '迭代',
    key: 'version_name',
    dataIndex: 'version_name',
    width: '12%'
  },
  {
    title: '完成时间',
    key: 'complete_time',
    dataIndex: 'complete_time',
    width: '12%'
  }
];

const issueColumns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'id',
    width: 100,
    scopedSlots: { customRender: 'issueId' }
  },
  {
    title: '缺陷标题',
    dataIndex: 'title',
    ellipsis: true,
    scopedSlots: { customRender: 'issueTitle' }
  },
  {
    title: '缺陷等级',
    key: 'serious',
    width: 120,
    scopedSlots: { customRender: 'serious' }
  }
];

function getIssuesCount(issues, serious) {
  let count = 0;
  issues.forEach(item => {
    if (item.serious === serious) {
      count += 1;
    }
  });
  return count;
}

export default {
  components: { IssueSeriousEdit, IssueSummary },
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      taskStatus,
      loading: false,
      expand: false,
      faultLevels,
      not_begin_list: [],
      doing: [],
      done: [],
      issues: [],
      issuesToday: [],
      projects: [],
      tagData: [],
      pagination: {
        size: 'small',
        total: 0,
        pageSize: 50, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      faultInfo: {},
      modalVisible: false,
      faultId: null,
      tableData: [],
      columns,
      issueColumns,
      seriesData: [],
      seriesDataToday: []
    };
  },
  computed: {
    taskLink() {
      return record => {
        const route = this.$router.resolve({ name: 'page:project:task:detail', query: { taskId: record.id }, params: { project_id: record.project }});
        return route.href;
      };
    },
    link() {
      return record => {
        return this.$router.resolve({ name: 'page:project:story:detail', params: { project_id: record.project_id }, query: { storyId: record.requirement_id }}).href;
      };
    },
    issueLink() {
      return record => {
        return this.$router.resolve({ name: 'page:project:quality:issue:detail', params: { project_id: record.project_id }, query: { issueId: record.id }}).href;
      };
    }
  },
  mounted() {
    this.getDiagramData();
  },
  methods: {
    onCopy,
    getDiagramData() {
      this.not_begin_list = [];
      this.done = [];
      this.doing = [];
      this.issues = [];
      this.issuesToday = [];
      getDiagramInfo(this.filterForm).then(res => {
        this.not_begin_list = res.data.not_begin;
        this.done = res.data.done.concat(res.data.finish).concat(res.data.ask_for_test).concat(res.data.prd_deploy).concat(res.data.qa_verify);
        this.doing = res.data.doing;
        this.issues = res.data.issues;
        this.issuesToday = res.data.issues_today;
        this.seriesData = [getIssuesCount(this.issues, 0),
          getIssuesCount(this.issues, 1),
          getIssuesCount(this.issues, 2),
          getIssuesCount(this.issues, 3)];
        this.seriesDataToday = [getIssuesCount(this.issuesToday, 0),
          getIssuesCount(this.issuesToday, 1),
          getIssuesCount(this.issuesToday, 2),
          getIssuesCount(this.issuesToday, 3)];
      });
    },

    onDetail(record) {
      this.$router.push({ name: 'page:event:fault:detail', query: { faultId: record.id }});
    },

    toggle() {
      this.expand = !this.expand;
    },

    reset() {
      // eslint-disable-next-line vue/no-mutating-props
      this.filterForm = {
        version_id: 1,
        user_group: 1
      };
      this.getDiagramData();
    }
  }
};
</script>

  <style lang="less" scoped>
  /deep/ .customer-filter {
    .ant-page-header {
      padding: 0;
    }

    // margin-bottom: 10px;

    .ant-form-item {
      margin-bottom: 8px;
      display: flex;

      .ant-form-item-control-wrapper {
        flex: 1;
      }
    }

    .filter-right {
      float: right;
      text-align: right;
    }
  }

  .edit-point {
    cursor: pointer;
    display: inline-block;
    padding: 0 4px;
    line-height: 22px;
  }

  .edit-point:hover {
    background-color: #e4e4e4;
  }

  .task-points {
    font-size: 11px;
    color: #8c95a8;
  }

  .filter-data {
    // margin-bottom: 16px;
    // margin-left: 10px;

    /deep/ .ant-card-body {
      padding: 16px;
    }
  }

  .corner {
    position: relative;
    background: linear-gradient(135deg, rgba(30, 216, 58, 0.4), transparent) #37ec3a;
  }

  .corner::before {
    position: absolute;
    bottom: -4px;
    left: -8px;
    font-size: 12px;
    height: 16px;
    content: '未填写结束时间';
    border-radius: 2px 2px 2px 0px;
    padding: 2px 4px;
    line-height: 12px;
    color: #fff;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #FF8433;
    background-blend-mode: soft-light;
  }

  .corner_reason1 {
    &:extend(.corner);
  }

  .corner_reason1::before {
    &:extend(.corner::before);
    content: '未填写结束时间';
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #FF8433;
  }

  .corner_reason2 {
    &:extend(.corner);
  }

  .corner_reason2::before {
    &:extend(.corner::before);
    content: '超过迭代完成时间';
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  }

  .corner_reason3 {
    &:extend(.corner);
  }

  .corner_reason3::before {
    &:extend(.corner::before);
    content: '请及时提审';
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  }

  .corner_issue_unfinished {
    &:extend(.corner);
  }

  .corner_issue_unfinished::before {
    &:extend(.corner::before);
    content: '未解决';
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  }
  </style>

